const discord_link = "https://scrimba.com/discord"
const upcoming_events_link = "https://scrimba.com/dashboard#overview"
const podcasts_link = "https://podcast.scrimba.com/"
# const power_hour_link = "https://community-handbook.scrimba.com/discord/experience-the-power-of-a-power-hour"
# Note: This `#block-` anchor tag is to the section above the help section, because our Notion -> "Super" publishing doesn't support anchor tags yet:
# const ask_a_question_link = "https://community-handbook.scrimba.com/discord/getting-started-in-the-scrimba-discord#block-3e918dcc229647a89cf634f0c9511a80"
const youtube_link = "https://www.youtube.com/c/Scrimba"
const challenge_week_link = "https://scrimba.com/learn/codeweeks"
# const townhall_link = "https://lu.ma/scrimba-townhall"

tag community-stats
	<self[d:grid mb:4 mt:4 @sm:0 jc:center ta:center us:none gtc:1fr 1fr @sm:25% 25% 25% 25% grid-gap:3.5rem @sm:3rem]>
		css div ta:center
		css svg h:80px w:90px pos:absolute l:1 @sm:5 @md:8 t:-6 @md:-2 r:0 @md:auto
		<div>
			<svg src="svg/blob5.svg" [c:$bubble-gum]>
			<h2.bg1> "132"
			<p> "countries{ <br> } and counting"
		<div>
			<svg src="svg/blob5.svg" [c:$coral]>
			<h2.bg1> "80"
			<p> "new members{ <br> } added daily"
		<div>
			<svg src="svg/blob5.svg" [c:$baby]>
			<h2.bg1> "5000"
			<p> "messages{ <br> } sent weekly"
		<div>
			<svg src="svg/blob5.svg" [c:$lemony]>
			<h2.bg1> "50"
			<p> "Qs answered{ <br> } each day"

tag community-page
	#user_count = 100

	css .header d:grid h:350px d:grid ai:center @900:flex-start bgc:teal4 bgc:$light-baby bgs:cover bgr:no-repeat
		h2 mt:0 @900:16
	css section w:100%

	css section.no-curve h:500px
		@before bg:none # TODO check all borders
	
	css .container px@md:4

	css .fade-to-left-blue w:250% h:100% pos:absolute mix-blend-mode:normal o:0.85
		bg: linear-gradient(271deg, rgba(74, 78, 116, 0.2) 17.65%, #4A4E74 59.9%)

	css .sub-grid-padded-content d:grid ta:left ja:center @md:start p:6 @md:0
	css .sub-grid-spaced-content d:grid ta:center ji:center grg:0.5rem 

	get user_count
		new Intl.NumberFormat().format(#user_count)

	set user_count data
		let from = Number(#user_count)
		let to = Number(data)
		let increments = 24
		let change = Number(to - #user_count)
		let frame = 0
		let incrementer
		
		def stop
			clearInterval(incrementer)

		incrementer = setInterval(&,(1000/24)) do
			let ease = 1 - Math.pow(1 - (frame / increments), 4)
			#user_count = from + Math.ceil(ease * change)
			imba.commit!
			frame < increments ? frame = frame + 1 : stop!

	def hydrate
		innerHTML = ''
		schedule!
		imba.commit!

	def build
		if $web$
			update-count()

	def update-count
		let url = 'https://discord.com/api/guilds/684009642984341525/widget.json?style=banner'
		try
			let res = await window.fetch(url)
			let data = await res.json!
			user_count = data.presence_count
		catch e
			user_count = 1024

	def render
		<self>
			<section.no-curve[min-height@lg:708px h@md:auto bg:$light-crab-cake]>
				<.container[mx:auto ta:center]>
					<h2[w:100% px:3 @sm:8 @lg:28 mt:8 mb:15]
						@intersect.out=window.flags.add('mod-sticky-header')
						@intersect.in=window.flags.remove('mod-sticky-header')
					> "Join a global community of friendly and helpful coders"
					<img[w:100% d:none @md:block] src="/static/photos/pages/community/world-chatting.jpg" alt="World map with users all over the globe chatting about code.">
					<img[w:100vw d@md:none] src="/static/photos/pages/community/world-globe.jpg" alt="World map with users all over the globe chatting about code.">


			<section.no-curve[c:white w:100vw h:100% bg:no-repeat url("/static/photos/pages/community/weekly-meetup.jpg") bgs:cover]>
				<.container[d:grid ja:center ai:flex-start gtc:1fr @md:1fr 1fr 1fr gcg:0 @md:3.125rem h:100%]>
					<.fade-to-left-blue>
					<div[ta:left as:center w:100%]>
						" "

					<div[mt:8 d:grid ja:start ta:left order:-1 zi:1 p:8 @md:0]> # z-index for Firefox
						<h2[ws:nowrap]> "{ user_count }{ <span[c:$moss]> "• " } peers { <br> } online right now"
						<p[pb:8]> "At any given time, there’s more than a thousand members online in our { <span.bold> "Discord " } server.  This means you will always have somewhere to go in case you need help, advice, or just want someone to chat with."
						<.community-cta[d:grid gac:min-content ac:baseline jc:center gcg:2rem]>
							<a.button[ml:0 mr:2 mb:4] href=discord_link target="_blank"> "Join The Community"

			<section[bg:$light-lemony px:12 w:100% mx:auto ta:center]>
					<h2[mb:8]> "{ <span[c:red]> "LIVE " } happenings throughout { <br> } the week... and year!"

					<.container[d:grid ja:center mx:auto gtc:1fr @md:1fr 1fr  ta:center grid-gap:3rem 4.75rem]>
						css .sub-grid-spaced-content max-width:450px
						<.sub-grid-spaced-content>
							<img[h:6] src="/static/photos/pages/community/logo-scrimba-text.svg" alt="Scrimba word logo">
							<img[w:100% mt:2 rd:2] src="/static/photos/pages/community/CodeReview.png" alt="Screenshot of code in Scrimba with high five illustration and banner saying 'Code Review of the Week' in front.">
							<p.bold>
								<a.bold href=discord_link target="_blank"> "Code Reviews"
							<p> "Improve your skills by giving and receiving peer code reviews."

						<.sub-grid-spaced-content>
							<img[h:6] src="/static/photos/pages/community/logo-discord-text.png" alt="Discord word logo">
							<img[w:100% mt:2 rd:2] src="/static/photos/pages/community/town-hall.jpg" alt="Town Hall - ask team Scrimba anything. Hear back immediately! Live every Tuesday 5pm GMT/Midday EST. Various members of the Scrimba team smiling and Pumpkin the tuxedo cat saying 'Welcome' in a speech bubble.">
							<p.bold>
								<a.bold href=discord_link target="_blank"> "Town Hall"
							<p> "News and views from Team Scrimba! Ask us anything! 💜"

						<.sub-grid-spaced-content>
							<img[h:6] src="/static/photos/pages/community/logo-youtube-text.png" alt="YouTube word logo">
							<img[w:100% mt:2 rd:2] src="/static/photos/pages/community/happening-ask-expert.jpg" alt="YouTube thumbnail for a live stream with Scrimba teacher Guil Hernandez called 'Learn how to learn'.">
							<p.bold>
								<a.bold href=youtube_link target="_blank"> "Ask an Expert"
							<p> "Valuable insights and advice from the best in the business"

						<.sub-grid-spaced-content>
							<img[h:6] src="/static/photos/pages/community/logo-youtube-text.png" alt="YouTube word logo">
							<img[w:100% mt:2 rd:2] src="/static/photos/pages/community/live-code-image-filters.jpg" alt="YouTube thumbnail for a live-code stream called 'Help us code image filters' Leanne holds a camera in the foreground and special guest, Scrimba Tutor Tom appears in a blue circle.">
							<p>
								<a.bold href=youtube_link target="_blank"> "Live-coding streams"
							<p> "Coding fun with Michael, Leanne, and Pumpkin the cat"

						<div[d:grid ji:center align-self:flex-start grg:0.5rem grid-column:span 1 @md:span 2]>
							<svg[d:none @md:block] src="svg/upcoming-events-blob.svg">
							<.community-cta[d:grid gac:min-content ac:baseline jc:center]>
								<a.button[d:none @lg:block] href=upcoming_events_link target="_blank"> "View Upcoming Events"
								<a.button[d:block @lg:none] href=upcoming_events_link target="_blank"> "See Events"


			<section[pb:55 @sm:40]> <.container[px:12 w:100% mx:auto ta:center]>
				<svg[d:none @md:block pos:absolute b:-34 l:-22 w:100%] src="svg/sparkles.svg">
				<h2[mb:8]> "Meet your hosts { <br> } and motivators"

				<.container[d:grid mx:auto ja:center gtc:1fr @md:1fr 1fr 1fr ta:center grid-gap:3rem 4.75rem mb:4]>
					css .sub-grid-spaced-content max-width:300px
					<.sub-grid-spaced-content>
						<img[w:60%] alt="Scrimba team member Leanne and her tuxedo cat, Pumpkin" src="/static/photos/pages/community/hosts-leanne.jpg">
						<p.bold>
							"Leanne "
							<a href="https://twitter.com/RybaLeanne" target="_blank"> "@RybaLeanne"
						<p> "Leanne live-codes and interviews industry experts on YouTube."

					<.sub-grid-spaced-content>
						<img[w:60%] src="/static/photos/pages/community/hosts-alex.jpg" alt="Scrimba podcast host Alex.">
						<p.bold>
							"Alex "
							<a href="https://twitter.com/bookercodes" target="_blank"> "@bookercodes"
						<p> "Alex hosts the weekly podcast interviews."

					<.sub-grid-spaced-content>
						<img[w:60%] src="/static/photos/pages/community/hosts-michael.jpg" alt="Scrimba team member Michael.">
						<p.bold>
							"Michael "
							<a href="https://twitter.com/alanmynah" target="_blank"> "@alanmynah"
						<p> "Michael is a Bootcamp Mentor and codes with Leanne on YouTube."

				
					<.sub-grid-spaced-content[grid-column:initial @md:span 3]>
						<h3> "And special guests..."
						<p> "We often invite industry experts to share their knowledge so that you can get an edge as you break into the tech industry."

				<img[d:none @350:block pos:absolute w:100% b:-30 ml:auto mr:auto l:0 r:0 ta:center] src="/static/photos/pages/community/avatars.png" alt="avatars for various well-known coders who have appeared at Scrimba events.">
				<img[d:block @350:none pos:absolute w:100% b:-40 ml:auto mr:auto l:0 r:0 ta:center] src="/static/photos/pages/community/avatars-small.png" alt="avatars for various well-known coders who have appeared at Scrimba events.">

			<section[bg:#F9F0E9 pt:12]>
				<svg[d:none @md:block pos:absolute w:100% t:-14 r:-74] src="svg/sparkles2.svg">

				<.container[d:grid ja:center gtc:1fr @md:1fr 1fr mx:auto gcg:4.75rem]>
					<.sub-grid-padded-content>
						<svg[d:none @md:block pos:absolute t:-10 r:3 w:464px h:524px transform:rotate(-38.24deg) c:#F5E6DB] src="svg/blob3.svg">
						<h2> "A weekly pod to { <span[d@lg:block]> } keep you inspired"
						<p[pt:4 pb:12]> "On { <span.bold> "The Scrimba Podcast," } you'll hear motivational advice and job-hunting strategies from developers who've been exactly where you are now. Both from fresh success stories and seasoned experts."
						<div> <a.button href=podcasts_link target="_blank"> "All Episodes"

					<img[w:100% p:6 @md:0] src="/static/photos/pages/community/podcast-graphic.jpg" alt="Four guests from the Scrimba podcast and the titles of their episodes.'No qualifications? No problem. Career Path: Frontend Developer. India.', 'International career building with Kent C Dodds', 'Becoming a six figure freelancer with Gary Simon', and 'Door Dash driver turned full-time developer' from the USA">

			<section.no-curve[bg:$light-moss h:110%]>

				<.container[px:12 ja:center mx:auto px:0]>
					<.container[d:grid ja:center gtc:1fr @md:1fr 1fr gcg:7rem mx:auto]>

						<div[order:1 @md:-1]>
							<svg[d:none @md:block pos:absolute t:-21% l:-38% w:380px h:380px c:#F5E6DB] src="svg/blob3.svg">
							<img[w:95vw @md:100%] src="/static/photos/pages/community/discord-testemonial-chat-messages.png" alt="Screenshots of coders asking for and receiving help on Scrimba's Discord server. Florence: 'Hi guys, so I've got this simple code to change the bg colour upon click. How do I make it go back to the original upon second click? And maybe change the icon too.' Noah:'@Florence You can add a class to the background and the icon. Then, instead of changing the style inline, you can use the classList to add or remove it. Or to make your code more dry, you can use the toggle method.' Benben:'Here's a link to how that could work...'">

						<.sub-grid-padded-content>
							<svg[d:none @md:block pos:absolute t:15% r:-14% w:410px h:410px transform:rotate(165deg) c:#F5E6DB] src="svg/blob9.svg">
							<h2> "Get unstuck in minutes"
							<p[p:8 0]> "We’ve all been there. You’re stuck with a bug you don’t know how to fix, which makes your motivation slip. Thankfully you’re not alone! Jump in the support channels and ask for a helping hand. You might just get unstuck in minutes!"
							<.community-cta[d:grid gac:min-content ac:baseline jc:center gcg:2rem]>
								<a.button[ml:0 mr:2 mb:4] href=discord_link target="_blank"> "Ask a Question"

					<community-stats>

			<section.no-curve[bg:$light-baby w:100vw h:100%]>
				<.container[d:grid ai:center gtc:1fr @md:1fr 1fr mx:auto gcg:5rem]>

					<img[w:95vw @md:100% order:1] src="/static/photos/pages/community/pair-up-cards.jpg" alt="Deepak in India and Joan in Kenya are mastering CSS together.">

					<.sub-grid-padded-content>
						<h2> "Find worldwide { <br> } coding friends"
						<p[p:8 0]> "Meet like-minded peers on our { <span.bold> "Discord Server" }. Set goals and help each other to smash them through our accountabilty channels. Ask for help at any time of the day or night - there's always someone online."
						<.community-cta[d:grid gac:min-content ac:baseline jc:center gcg:2rem]>
							<a.button[ml:0 mr:2 mb:4] href=discord_link target="_blank"> "Make friends now"

			<section.no-curve[bg:$light-moss w:100vw h:100%]>
				<.container[d:grid ai:center ji:end gtc:1fr @md:1fr 1fr mx:auto gcg:8rem]>

					<.sub-grid-padded-content>
						<h2> "Power Hours to { <br> } keep you focused"
						<p[p:8 0]> "A distraction-free, highly focused hour where you work on an important task that moves you forward. Power hours take place in the Scrimba Discord 4x a day in order to suit most time zones.  Show up every weekday for a month, and you'll be shocked at how much progress you make!"
						<.community-cta[d:grid gac:min-content ac:baseline jc:center gcg:2rem]>
							<a.button[d:none @md:block ml:0 mr:2 mb:4] href=discord_link target="_blank"> "Join Power Hours"

					<img[w:95vw @md:100% order:1 @md:-1] src="/static/photos/pages/community/power-hour-graphic.png" alt="Grapic showing eight users all connecting via the Power Hour. Screensharing on, notification off, deep focus."> 

			# testimonials section - reconsider
			# core values section - reconsider

			<section[bg:$light-baby w:100vw h:100% of:hidden py:14 @sm:20]>
				<svg[d:none @md:block pos:absolute l:-18 t:-23 w:428px h:371px c:#DEEBF8] src="svg/blob1.svg">
				<svg[d:none @md:block pos:absolute b:-58 r:-39 w:428px h:371px c:#DEEBF8] src="svg/blob1.svg">

				<.container[d:flex fld:column bg:$medium-bubble-gum p:8 of:hidden rd:20px bxs:0px 2px 40px rgba(0, 0, 0, 0.4) mx:4 @lg:auto my:8 ta:center @sm:left]>
					<svg[pos:absolute l:2% b:-55% w:250px transform:rotate(65deg) c:$medium-lemony] src="svg/blob1.svg">
					<svg[pos:absolute l:20% t:-10% w:250px c:$medium-lemony] src="svg/blob1.svg">
					<svg[pos:absolute l:62% t:15% w:400px transform:rotate(165deg) c:$medium-lemony d:none @sm:block] src="svg/blob1.svg">
					<svg src="svg/peep-crowd2.svg" [pos:absolute d:none @md:initial b:-4 r:-52 transform:scale(-1,1)] loading="lazy" alt="Illustration of a group of happy people">
					<h2.reveal> "Welcome friend!"
					<p[my:4 max-width:520px].bold> "Right now there are { user_count }{ <span[c:$moss]> "• " }  peers on the Scrimba Discord server. Join us and start exploring what there is on offer."
					<a.button[mx:0 my:8 d:none @400:block] href=discord_link target="_blank"> "Join The Community"
					<a.button[mx:auto d@400:none my:8] href=discord_link target="_blank"> "Join The Community"
